
import { jsonParse } from "../../../wp-utils/v1";
import getClickAbleDom from "../utils/getClickAbleDom.js";
import renderModel from "../utils/renderModel";

import "./product.js";

/**
 * Render
 */
document.addEventListener("DOMContentLoaded", function () {
    const models = document.querySelectorAll(".modelViewerBlock");
    if (window.domRendered) {
        return;
    }
    window.domRendered = true;
    models.forEach((dom) => {
        const dataset = { ...dom.dataset } || {};
        setTimeout(() => {
            Object.keys(dom.dataset).map((key) => delete dom.dataset[key]);
        }, 10);

        const attributes = jsonParse(dataset.attributes);

        if (attributes) {
            const selector = dataset.selector;
            const position = dataset.position;
            const unique_class = dataset.uniqueClass;
            const type = dataset.type;
            const { isPagination, styles } = attributes;

            const div = document.createElement("div");
            if (selector && getClickAbleDom(selector)) {
                Object.keys(dom.dataset).map((key) => delete dom.dataset[key]);
                dom = getClickAbleDom(selector);

            } else {
                window.modelViewerMessages.push({ dom, selector, message: "does not have any dom with this selector" });
            }
            if (!attributes?.currentViewer || attributes.currentViewer === "modelViewer") {
                dom.setAttribute("data-rendered", "true");
                div.classList.add("woocommerce-product-model-viewer-wrapper");
                div.classList.add(`position_${position}`);
                dom.classList.add(`product_${unique_class}`);
                renderModel({ div, dom, position, styles, isPagination, attributes, type });
                const Src = document.getElementById("bp3d-model-viewer-js");
                if (!Src) {
                    const script = document.createElement("script");
                    script.type = "module";
                    script.id = "bp3d-model-viewer-js";
                    script.src = window["bp3dBlock"]?.modelViewerSrc;
                    document.head.appendChild(script);
                }
            }
            if (attributes.currentViewer === "O3DViewer") {
                const Src = document.getElementById("bp3d-o3dviewer-js");
                if (!Src) {
                    const script = document.createElement("script");
                    script.id = "bp3d-o3dviewer-js";
                    script.src = window["bp3dBlock"]?.o3dviewerSrc;
                    document.head.appendChild(script);
                    script.addEventListener("load", () => {
                        renderModel({ div, dom, position, styles, isPagination, attributes, type });
                    });
                } else {
                    Src.addEventListener("load", () => {
                        renderModel({ div, dom, position, styles, isPagination, attributes, type });
                    });
                }
            }
        }
    });
});


